import Vue from 'vue'
import App from './App.vue'
import VueCarousel from 'vue-carousel'
import VueRouter from 'vue-router'

Vue.config.productionTip = false;
Vue.use(VueCarousel);
Vue.use(VueRouter);

import Home from './components/Home.vue'
import ServiceList from './components/ServiceList.vue'
import CGU from './components/CGU.vue'
import Charte from './components/Charte.vue'
import Demarche from './components/Demarche.vue'
import Notice from './components/Notice.vue'
import Description from './components/Description.vue'


const router = new VueRouter({
    base: __dirname,
    routes: [
        { path: '/', name: 'home', component: Home },
        { path: '/description', name: 'description', component: Description },
        { path: '/list', name: 'list', component: ServiceList, props: (route) => ({ cat: route.query.cat }) },
        { path: '/cgu', name: 'cgu', component: CGU },
        { path: '/charte', name: 'charte', component: Charte },
        { path: '/demarche', name: 'demarche', component: Demarche },
        { path: '/notice', name: 'notice', component: Notice }
    ]
});


new Vue({
    router: router,
    render: h => h(App),
}).$mount('#app')
